import PageTranslationHOC from "Components/Utils/i18n/PageTranslationHOC";
import { Redirect, Route, useLocation } from "react-router-dom";
import * as ROUTES from "../../Constants/Routes";
import { URL_PARAMS } from "../../Constants/globals";

import clientV2 from "lib/apollo-v2";
import { useMeQuery } from "lib/apollo-v2/generated/graphql";
import Error from "./Error";
import { useEffect } from "react";
import Loading from "./Loading";

const PrivateRoute = ({ component: RouteComponent, lookupKey, ...rest }) => {
  const { pathname, search } = useLocation();

  // const token = localStorage.getItem("token");

  const getSearchParams = new URLSearchParams(search)?.toString();
  let setSearchParams = null;
  if (getSearchParams) {
    setSearchParams = `&${new URLSearchParams(search)?.toString()}`;
  }

  const {
    data: userData,
    loading: userLoading,
    error: userError,
  } = useMeQuery({
    // client: clientV2,
    // variables: { token },
    // skip: token === null,
  });
  if (!userLoading && userError?.message === "unauthenticated!") {
    //token expired, or is invalid!
    localStorage.removeItem("token");
    return (
      <Redirect
        to={`${ROUTES.LOGIN}?${URL_PARAMS.REDIRECT}=${pathname}${
          setSearchParams ?? ""
        }`}
      />
    );
  }

  if (userLoading) {
    return <Loading />;
  }

  // if (userLoading) return <LoadingLogoFullScreen />;
  if (userError) return <Error />;

  return (
    <Route
      {...rest}
      render={(routeProps) =>
        !!userData && !!userData.result ? (
          <PageTranslationHOC>
            <RouteComponent {...routeProps} />
          </PageTranslationHOC>
        ) : (
          <Redirect
            to={`${ROUTES.LOGIN}?${URL_PARAMS.REDIRECT}=${pathname}${
              setSearchParams ?? ""
            }`}
          />
        )
      }
    />
  );
};

export default PrivateRoute;
